import { register } from "async-ops";
import { callMvcApi } from "../../call-web-api";
export const GET_USER_PREFERENCE = "GET_USER_PREFERENCE";

export const service = async (data) => { 
  const options: object = {    
    url: `/api/utility/GetUserPreference/` + data.name+`/` +data.reportType,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return null;
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_USER_PREFERENCE, service, mock);
